import styled from "styled-components/macro";

const StyledSvg = styled.svg`
  &:not(.disableAnimation) {
    #call-icon-circle1 {
      animation: dash1 1s linear infinite;
    }

    #call-icon-circle2 {
      animation: dash2 1s linear infinite;
    }
  }
  @keyframes dash1 {
    from {
      r: 22;
    }
    to {
      r: 28;
    }
  }

  @keyframes dash2 {
    from {
      r: 28;
      opacity: 1;
    }
    to {
      r: 33;
      opacity: 0;
    }
  }
`;

export default function CallIconAnimated({
  isCallAnimationActive,
}: {
  isCallAnimationActive: boolean;
}) {
  return (
    <StyledSvg
      className={`${isCallAnimationActive ? "" : "disableAnimation"}`}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="-13.35 -13.34 70 70"
    >
      <g id="Layer_1-2" data-name="Layer 1">
        <circle
          className="call-icon-circle"
          cx="21.35"
          cy="21.34"
          r="22"
          fill="none"
          strokeWidth="1.5"
        />
        <circle
          id="call-icon-circle1"
          cx="21.35"
          cy="21.34"
          r="23"
          fill="none"
          strokeWidth="2"
        />
        <circle
          id="call-icon-circle2"
          cx="21.35"
          cy="21.34"
          r="27"
          fill="none"
          strokeWidth="2"
        />
        <svg viewBox="0.3 0.3 32 32" xmlns="http://www.w3.org/2000/svg">
          <path
            stroke="none"
            d="M10 0C4.47273 0 0 4.47273 0 10C0 15.5273 4.47273 20 10 20C15.5273 20 20 15.5273 20 10C20 4.47273 15.5273 0 10 0ZM14.9273 15.3455C14.6364 15.6545 14.3091 15.9273 14.0364 16.2364C13.6545 16.6545 13.0909 16.8727 12.5273 16.8182C11.6909 16.7455 10.8727 16.5091 10.1273 16.1273C8.47273 15.3091 7 14.1636 5.81818 12.7455C4.90909 11.7091 4.2 10.5091 3.70909 9.23636C3.45455 8.61818 3.32727 7.94545 3.34545 7.27273C3.36364 6.87273 3.54545 6.47273 3.85455 6.2C4.18182 5.87273 4.50909 5.54545 4.83636 5.21818C5.18182 4.83636 5.76364 4.8 6.14545 5.12727C6.18182 5.14545 6.2 5.18182 6.23636 5.21818C6.50909 5.47273 6.76364 5.74545 7.01818 6C7.27273 6.25455 7.52727 6.50909 7.78182 6.76364C8.23636 7.21818 8.23636 7.74545 7.78182 8.2C7.45455 8.52727 7.14545 8.85455 6.81818 9.16364C6.74545 9.21818 6.72727 9.32727 6.76364 9.41818C6.98182 9.92727 7.27273 10.4 7.63636 10.8182C8.32727 11.6909 9.14545 12.4364 10.0909 13.0364C10.2909 13.1636 10.5273 13.2545 10.7273 13.3636C10.8182 13.4182 10.9273 13.4 11 13.3091C11.3273 12.9818 11.6364 12.6545 11.9818 12.3273C12.3091 11.9455 12.8909 11.8909 13.2909 12.2364C13.3273 12.2727 13.3636 12.2909 13.3818 12.3273C13.9091 12.8545 14.4364 13.3636 14.9455 13.8909C15.3818 14.3636 15.3636 14.9091 14.9273 15.3455ZM9.87273 7.29091L10.0182 6.27273C11.9636 6.54545 13.5091 8.05455 13.8545 10L12.8364 10.1818C12.5818 8.67273 11.3818 7.50909 9.87273 7.29091ZM15.5091 10C15.0364 7.21818 12.8 5.05455 10 4.65455L10.1455 3.63636C13.3818 4.09091 15.9636 6.6 16.5273 9.81818L15.5091 10Z"
          />
        </svg>
      </g>
    </StyledSvg>
  );
}
